// Import CalendarFilters for use in DEFAULT_FILTERS
import type { CalendarFilters } from './index';

// Re-export filter types from main types file
export type { CalendarFilters, FilterStats } from './index';

export const DEFAULT_FILTERS: CalendarFilters = {
  resourceTypes: [],
  departments: [],
  resources: [],
  roles: [],
  utilisationRange: [0, 100],
  overUtilisedOnly: false,
  projects: [],
  projectStatuses: [],
  costCentres: [],
  costCentreStatuses: [],
  bookingTypes: [],
  bookingStatuses: [],
};

export interface FilterOption {
  id: string;
  label: string;
  value: string;
}

// Advanced Filter Types
export type AdvancedFilterOperator = 'equals' | 'not-equals' | 'contains' | 'not-contains' | 'starts-with' | 'ends-with' | 'greater-than' | 'less-than' | 'between' | 'is-empty' | 'is-not-empty' | 'in' | 'not-in';

export type AdvancedFilterFieldType = 'text' | 'number' | 'date' | 'datetime' | 'boolean' | 'select' | 'multi-select' | 'time';

export interface AdvancedFilterField {
  fieldName: string;
  displayName: string;
  fieldType: AdvancedFilterFieldType;
  operators: AdvancedFilterOperator[];
  options?: { value: string; label: string }[]; // For select/multi-select fields
  placeholder?: string;
}

export interface AdvancedFilterCondition {
  id: string;
  fieldName: string;
  operator: AdvancedFilterOperator;
  value: any;
  value2?: any; // For 'between' operator
}

export interface AdvancedFilters {
  conditions: AdvancedFilterCondition[];
  logicOperator: 'AND' | 'OR';
}

export const DEFAULT_ADVANCED_FILTERS: AdvancedFilters = {
  conditions: [],
  logicOperator: 'AND',
};
